import { memo } from "react";
import classNames from "classnames";
import { MenuListProps } from "react-select";
import { Scrollbars } from "../../../ui";

import styles from "./style.module.scss";

export const MenuList = memo<MenuListProps<any>>((props) => {
  const { children, className, cx, getStyles, isMulti, innerRef } = props;

  const selectStyles = { ...getStyles("menuList", props) } as any;
  return (
    <div
      style={{
        ...selectStyles,
        overflow: "hidden",
        "--maxHeight": typeof selectStyles.maxHeight === "number" ? `${selectStyles.maxHeight}px` : selectStyles.maxHeight,
      }}
      className={classNames(
        cx(
          {
            "menu-list": true,
            "menu-list--is-multi": isMulti,
          },
          className),
        styles.menuList,
      )}
    >
      <Scrollbars
        options={{
          className: styles.menuListScrollbar,
          callbacks: {
            onInitialized: function () {
              // do nothing
              // needed for correct default scroll position
            },
          },
        }}
        ref={(ref) => (innerRef as any)(ref?.osInstance()
          ?.getElements()?.viewport)}
      >
        {children}
      </Scrollbars>
    </div>
  );
});
